<template>
	<div id="wangeditor">
		<div ref="editor" style="text-align:left; height: 300px;"></div>
	</div>
</template>

<script>
	import Editor from "wangeditor";
	import axios from 'axios'

	export default {
    inject: ['$http', '$api', '$utils'],
		name: "editor",
		data() {
			return {
				editor: null,
				editorContent: "",
				imgUrl: "",
                isChange:false,
			};
		},
		props: ["catchData", "content"], // 接收父组件的方法
		watch: {
          "chartData": {
                handler() {
                  if(!this.isChange){
                    this.editor.txt.html(this.content);
                  }
                  this.isChange= false;
                }
          }
		},
		mounted() {
			this.editor = new Editor(this.$refs.editor);
                console.log(this.editor);
                this.editor.config.onchange = html => {

                    // 保存当前的光标位置
                    const selection = window.getSelection();
                    const range = selection.rangeCount ? selection.getRangeAt(0) : null;

                    console.log(selection)
                            console.log(range);
                            this.editorContent = html;
                            this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件

                    // 恢复光标位置
                    if (range) {
                      selection.removeAllRanges();
                      selection.addRange(range);
                    }
                };
			this.editor.config.showLinkImg = false;
			this.editor.config.uploadImgShowBase64 = true;
			this.editor.config.uploadFileName = "content";
			this.editor.config.uploadImgMaxLength = 1; //限制只能上传一张图
			this.editor.config.menus = [
				// 菜单配置
				"head", // 标题
				"bold", // 粗体
				"fontSize", // 字号
				"fontName", // 字体
				"italic", // 斜体
				"underline", // 下划线
				"strikeThrough", // 删除线
				"foreColor", // 文字颜色
				"backColor", // 背景颜色
				"link", // 插入链接
				"list", // 列表
				"justify", // 对齐方式
				"quote", // 引用
				"emoticon", // 表情
				"image", // 插入图片
				"undo", // 撤销
				"redo" // 重复
			];

			let that = this;
          console.log("aaaa")
          console.log(that.$api.getOssUniKeyApi)

			/* 自定义图片上传（支持跨域和非跨域上传，简单操作）*/
			this.editor.config.customUploadImg = function(files, insert) {
				console.log(files);
				let file = files[0];
				let point = file.name.lastIndexOf(".");
				let suffix = file.name.substr(point);
				let fileName = file.name.substr(0, point);
				let date = Date.parse(new Date());
				let fileNames = `${fileName}_${date}${suffix}`;

				let OSS_BUCKET_EDITOR = "mytutu-bj-editor"; //空间名称
				let OSS_BUCKET_EDITOR_UPLOAD_URL = "https://" + OSS_BUCKET_EDITOR + ".oss-cn-beijing.aliyuncs.com"; //富文本编辑器空间文件上传提交地址
				let OSS_BUCKET_EDITOR_DOMAIN = "https://ue.meiyintutu.com/"; //域名

				// fileNames上传文件的名称   file.file上传文件的内容
				let formData = new FormData()
				formData.append("file", file);

				//获取上传图片的ossUniKey
				axios({
					method: 'post',
					url: that.$api.getOssUniKeyApi,
					data: "suffix=" + suffix,
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
					}
				}).then(response => {
					console.log(response);
					//获取上传图片的ossUploadToken
					axios({
						method: 'post',
						url: that.$api.getOssUploadTokenApi,
						data: "bucket=" + OSS_BUCKET_EDITOR,
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
						}
					}).then(responseToken => {
            console.log(responseToken);
						let formdata = new FormData();
						formdata.append('success_action_status', "200"); //让服务端返回200,不然，默认会返回204
						formdata.append('key', response.data);
						formdata.append('OSSAccessKeyId', responseToken.data.accessid);
						formdata.append('policy', responseToken.data.policy);
						formdata.append('callback', responseToken.data.callback);
						formdata.append('signature', responseToken.data.signature);

						let xhr = new XMLHttpRequest();
						xhr._fileObject = file;
						
						//上传进度监听
						xhr.upload.addEventListener("progress", function(e) {
							that.$loading();
							let progress = (e.loaded / e.total) * 100;
							if(progress >= 100) {
								that.$loading().close();
							}
						})
						xhr.addEventListener("load", function(e) {
							var result = JSON.parse(e.target.response);
							console.log(e);
							if (result.status == "ok") {
                insert(OSS_BUCKET_EDITOR_DOMAIN + result.name);
                response.host = ossUploadToken.host.replace("-internal", "");
                response.url = ossUploadToken.url;
                return resolve(response)
							}
						})

						//添加必要自定义的文件属性
						formdata.append("x-oss-meta-company", "mytutu");
						//这里有个特别需要注意的地方就是，用户自定义参数的Key一定要以x:开头，且必须为小写。否则OSS会返回错误
						formdata.append("x:filetype", "image");
						//向表单中添加要上传的文件(一定要是formdata的最后一个域)
						formdata.append("file", file);
						//开始上传
						//开启POST请求
						xhr.open("POST", responseToken.data.host.replace("-internal", ""), true);
						//待文件数组减1
						files.splice(0, 1);
						//提交表单上传
						xhr.send(formdata);
					})
				}, err => {
					console.log(err);
				})
			};

			this.editor.create(); // 创建富文本实例
			if (!this.content) {
				this.editor.txt.html("");
			}
		},
        methods:{
            clearContent() {
                this.isChange = true; // 标记主动清空操作，避免 watch 中 content 重置内容
                this.editor.txt.clear(); // 清空编辑器内容
                this.catchData(""); // 通知父组件数据已清空
            }
        }

	};
</script>
<style>
	.w-e-text-container {
		height: calc(300px - 33px) !important;
	}
</style>
